module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#int_1"
    }
  }, [_vm._v("Basics for Healthy Eating on a Budget")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_c('strong', [_vm._v("Shopping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#ch01_1"
    }
  }, [_vm._v("Shop Smarts at Grocery Stores")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#ch01_2"
    }
  }, [_vm._v("Shop Smart at Farmers’ Market")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Breakfast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#ch02_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Roll Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#ch02_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunrise Granola")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#ch02_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frittata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#ch02_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Rice Egg Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#ch02_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast Burrito")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#ch02_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grab and Go Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#ch03_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hearty Vegetable Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#ch03_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Broccoli Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#ch03_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and Dumpling Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03#ch03_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Soup: Your Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Salads")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#ch04_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crunchy Apple and Cabbage Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#ch04_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Cornbread Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#ch04_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Taco Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#ch04_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Salad Dressings: Your Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Vegetables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#ch05_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Oven Zucchini “Fries”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#ch05_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#ch05_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Pickles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05#ch05_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Vegetables: Your Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("One-Pot Meals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06#ch06_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvest Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06#ch06_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Broccoli Alfredo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06#ch06_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southwestern Chicken and Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06#ch06_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making One Pot Meals: Your Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Slow Cooker Meals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07#ch07_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Beef Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07#ch07_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Barbecue Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07#ch07_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Soup Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07#ch07_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Slow Cooker Meals: Your Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Snacks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08#ch08_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stovetop Popcorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08#ch08_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Crisp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08#ch08_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08#ch08_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grab and Go Snacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kentucky Proud Produce Availability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Youth Friendly Kitchen Tasks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guide to Portion Sizes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measurements and Substitutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knife Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbs and Spices: Your Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Home Cooking Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasting a Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appenidx#app01_7_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Basic Ways to Prepare Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Recipe Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb521b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0